import React, { Component } from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import classnames from 'classnames';
import Job from './Job';
import Pagination from 'ps-components/Pagination/Pagination';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import './JobSearchResults.scss';

class JobSearchResults extends Component {
  static propTypes = {
    className: string,
    containerClass: string,
    paginationContainerClass: string,
    hasResults: bool,
    isSelected: bool,
    offset: number,
    currentOpenJobId: oneOfType([string, number]),
    orgJobs: arrayOf(
      shape({
        orgJobCode: string,
        orgJobCodeKey: string,
        currency: string,
        orgJobId: string,
        orgJobTitle: string
      })
    ),
    onPageOrgJobs: func,
    replacementTokens: arrayOf(
      shape({
        key: string
      })
    ),
    onSelectJob: func,
    totalCount: number,
    useJobCodeKey: bool,
    selectedJobId: oneOfType([string, number]),
    showSearch: bool
  };

  constructor(props) {
    super(props);
  }

  renderJobs = () => {
    const { orgJobs, replacementTokens, useJobCodeKey, selectedJobId, currentOpenJobId } = this.props;
    if (selectedJobId && orgJobs)
      return orgJobs.map(job => {
        const isCurrentJob = parseInt(currentOpenJobId) === parseInt(job.orgJobId);
        return (
          <Job
            job={job}
            key={job.orgJobId}
            replacementTokens={replacementTokens}
            selectedJob={selectedJobId}
            onSelectJob={this.onSelectJob}
            useJobCodeKey={useJobCodeKey}
            isCurrentJob={isCurrentJob}
            isDisabled={isCurrentJob}
          />
        );
      });
  };

  onSelectJob = job => {
    const { onSelectJob, selectedJobId } = this.props;
    if (selectedJobId !== job.orgJobId && onSelectJob) onSelectJob(job);
  };

  render() {
    const {
      className,
      hasResults,
      offset,
      onPageOrgJobs,
      showSearch,
      totalCount,
      containerClass,
      paginationContainerClass
    } = this.props;
    const paginationClass = classnames({
      org_jobs__pagination: showSearch,
      'org_jobs__pagination-only': !showSearch
    });
    return (
      <div className={classnames(containerClass)}>
        {!hasResults ? (
          <div className="org_jobs__placeholder">
            <Placeholder
              className="pxl-text-small pxl-text-muted"
              imagePath="/view/static/mp/images/empty_results.svg"
              secondaryText="There are no results for your search criteria."
              showText={true}
            />
          </div>
        ) : (
          <React.Fragment>
            <div className={classnames(className, 'org__jobs-common')}>{this.renderJobs()}</div>
            <Pagination
              pageShowRange={1}
              containerClassName={paginationContainerClass}
              className={paginationClass}
              offset={offset}
              pageAction={onPageOrgJobs}
              step={50}
              totalCount={totalCount}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default JobSearchResults;
